import {
  EDELVIVES_DIGITAL_PLUS,
  GOTITBYME,
  MACMILLAN,
  SANTILLANA_BR_COMPARTIR,
  SANTILLANA_BR_MODERNAEDUCACAO,
  SANTILLANA_BR_UNOI,
  SANTILLANA_CR_COMPARTIR,
  SANTILLANA_DO_COMPARTIR,
  SANTILLANA_GT_COMPARTIR,
  SANTILLANA_HN,
  SANTILLANA_MX_COMPARTIR,
  SANTILLANA_NI_COMPARTIR,
  SANTILLANA_PA_COMPARTIR,
} from './resourcesByTenant';
import { DEFAULT_RESOURCES_EN, DEFAULT_RESOURCES_ES, DEFAULT_RESOURCES_PT } from './resourcesDefault';

export default {
  //TRADUCCIONES POR DEFECTO
  es: DEFAULT_RESOURCES_ES,
  en: DEFAULT_RESOURCES_EN,
  pt: DEFAULT_RESOURCES_PT,
  //TRADUCCIONES POR TENANT
  ...GOTITBYME,
  ...MACMILLAN,
  ...SANTILLANA_MX_COMPARTIR,
  ...SANTILLANA_CR_COMPARTIR,
  ...SANTILLANA_DO_COMPARTIR,
  ...SANTILLANA_GT_COMPARTIR,
  ...SANTILLANA_BR_COMPARTIR,
  ...SANTILLANA_BR_MODERNAEDUCACAO,
  ...SANTILLANA_BR_UNOI,
  ...SANTILLANA_HN,
  ...SANTILLANA_NI_COMPARTIR,
  ...SANTILLANA_PA_COMPARTIR,
  ...EDELVIVES_DIGITAL_PLUS,
};
